/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Informationen zur Auswahl eines Zaehlers
 */
export interface ZaehlerIdentifier { 
    sparte?: string;
    equipment?: string;
    /**
     * number of a meter
     */
    meterNumber?: string;
    inaktiv?: boolean;
    /**
     * is true if it is a smart-meter, default false
     */
    isSmartMeter?: boolean;
}

